var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm._.container,
    _vm.noPager && _vm._.noPager,
    _vm.theme.gridType === 1 && _vm._.style2 ],style:({
    '--cols': _vm.theme.rowCount,
    '--padding': _vm.$transformPx(_vm.theme.innerMargin || 0),
  })},[_c('van-swipe',{class:_vm._.grids},_vm._l((_vm.groupData),function(group,groupIndex){return _c('van-swipe-item',{key:groupIndex,class:_vm._.grid},_vm._l((group),function(item,itemIndex){return _c('div',{directives:[{name:"track",rawName:"v-track",value:({
          name: '图标宫格-项目',
          id: "DianJiZiDingYiYeZiYuan",
          resource: item,
          index: itemIndex,
          extra: item && _vm.getTrackExtra(item, itemIndex),
        }),expression:"{\n          name: '图标宫格-项目',\n          id: `DianJiZiDingYiYeZiYuan`,\n          resource: item,\n          index: itemIndex,\n          extra: item && getTrackExtra(item, itemIndex),\n        }"}],key:itemIndex,class:_vm._.item,on:{"click":function($event){return _vm.$dmbcResourceClick(item)}}},[(item)?[_c('img',{class:_vm._.icon,attrs:{"src":item.icon}}),_c('div',{class:_vm._.label},[_vm._v(_vm._s(item.title))])]:_vm._e()],2)}),0)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }